const remoteURL = "https://systemapi.midda.org/api/";
const localURL = "http://127.0.0.1:8000";

const constants = {
    remoteURL,
    localURL
}

export default constants;